import dayjs from 'dayjs'
import { PriceStatusCode } from '@/services/settlement/settlementPricing/types'

export const PRICING_TAB = {
  BASE: 'BASE', // 기본단가
  CATEGORY: 'CATEGORY', // 카테고리 단가
} as const

export type PricingTabValue = (typeof PRICING_TAB)[keyof typeof PRICING_TAB]

// 단위 — PCS / box / 송장 (화면기획서 §4).
// 송장(INVOICE)은 unit_type 이 아니라 service_charge_base.charge_base_type 축 → 기본단가 검색 시 chargeBaseType 파라미터로 분기 전송한다 (LOGISPRD-9878, BasePriceTab.toReq).
export const UNIT_OPTIONS = [
  { label: 'PCS', value: 'PCS' },
  { label: 'box', value: 'BOX' },
  { label: '송장', value: 'INVOICE' },
]

// 카테고리 단가 등록용 단위 — PCS/box 만 선택 가능 (송장 제외 — LOGISPRD-9632).
// 택배비·도서산간비 + box 조합은 BE 검증에서 차단(알럿 문구 노출).
export const UNIT_REGISTER_OPTIONS = UNIT_OPTIONS.filter((o) => o.value !== 'INVOICE')

// 주문유형(채널) — DOMESTIC(국내) / GLOBAL(해외) (LOGISPRD-9172/9175)
export const ORDER_TYPE_OPTIONS = [
  { label: '국내', value: 'DOMESTIC' },
  { label: '해외', value: 'GLOBAL' },
]

// 상태 — 대기 / 진행중 / 종료 (조회일 기준 동적)
export const STATUS_OPTIONS = [
  { label: '대기', value: 'PENDING' },
  { label: '진행중', value: 'ACTIVE' },
  { label: '종료', value: 'ENDED' },
]

// 상태 정렬 우선순위 (진행중 → 대기 → 종료)
export const PRICE_STATUS_ORDER: Record<PriceStatusCode, number> = {
  ACTIVE: 0,
  PENDING: 1,
  ENDED: 2,
}

/**
 * 단가 상태를 조회일(오늘) 기준으로 동적 판정한다. (LLD §3.6 / FR-PM06)
 * - 종료일 < 오늘  또는  종료일 < 시작일(대기중 종료) → 종료(ENDED)  ※ 종료를 대기보다 우선
 * - 시작일 > 오늘 → 대기(PENDING)
 * - 그 외 → 진행중(ACTIVE)
 */
export const resolvePriceStatus = (startDate: string, endDate?: string | null, today = dayjs()): PriceStatusCode => {
  if (endDate && (dayjs(endDate).isBefore(today, 'day') || dayjs(endDate).isBefore(dayjs(startDate), 'day'))) {
    return 'ENDED'
  }
  if (dayjs(startDate).isAfter(today, 'day')) {
    return 'PENDING'
  }
  return 'ACTIVE'
}
